<template>

    <div class="behavior-report">
        <tool-container>
            <template v-slot:tabs>
                <b-tab title="Compose" >
                    <tool-container-compose-toolbar>
                    </tool-container-compose-toolbar>

                    <behavior-report-step1 v-if="onStep(1)">
                    </behavior-report-step1>

                    <behavior-report-step2 v-if="onStep(2)">
                    </behavior-report-step2>

                    <behavior-report-step3 v-if="onStep(3)">
                    </behavior-report-step3>
                </b-tab>

                <b-tab title="Preview">
                    <tool-container-preview-toolbar :landscape="landscape">
                    </tool-container-preview-toolbar>

                    <behavior-report-preview :landscape="landscape">
                    </behavior-report-preview>
                </b-tab>
            </template>
        </tool-container>
    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import BehaviorReportMixin from "@/providers/BehaviorReportMixin";

    export default Vue.extend({
        name: "BehaviorReport",
        mixins: [ToolMixin, BehaviorReportMixin],
        computed: {
            landscape() {
                return this.docData.periodOption && this.docData.periodOption !== 'daily'
            }
        }
    })

</script>

<style>
</style>


